import { axios, HOST, config } from "./settiing";

export default {
  /** driver api */
  getDriverList(params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(`${HOST}/resource/web/driver?${query}`, config);
  },
  getDriverListForExcel(params) {
    return axios.get(`${HOST}/resource/web/driver/excel`, config);
  },
  addDriver(data) {
    return axios.post(`${HOST}/resource/driver`, data, config);
  },
  getDriver(driverId) {
    return axios.get(`${HOST}/resource/driver/${driverId}`, config);
  },
  deleteDriver(driverId) {
    return axios.delete(`${HOST}/resource/driver/${driverId}`, config);
  },
  deleteDrivers(drivers) {
    return axios.post(`${HOST}/resource/driver/bulk/remove`, drivers, config);
  },
  updateDriver(data) {
    return axios.put(`${HOST}/resource/driver`, data, config);
  },
  getDriversByDate(start, end) {
    return axios.get(`${HOST}/resource/driver/date/${start}/${end}`, config);
  },

  getAvailableDriverList() {
    return axios.get(`${HOST}/resource/driver/available`, config);
  },

  checkDriverMobileNo(data) {
    return axios.get(`${HOST}/resource/driver/search/${data}`, config);
  },

  checkDriverLicenseNo(data) {
    return axios.get(
      `${HOST}/resource/driver/search/byLicense/${data}`,
      config
    );
  },

  driverBulkRegist(data) {
    return axios.post(`${HOST}/resource/driver/bulk`, data, config);
  },

  getMGDriverList() {
    return axios.get(`${HOST}/resource/mg/driver`, config);
  },

  getMGDriverListByDate(start, end) {
    return axios.get(`${HOST}/resource/mg/driver/${start}/${end}`, config);
  },

  getDriverADAS(id) {
    return axios.get(`${HOST}/resource/mg/driver/adas/${id}`, config);
  },
};
